/* Extracted 2026-10-13 from layout/theme.liquid (inline block 17) — SEO round 3 step 3, audit C1. Loaded at the same position, synchronously. Edit here; the Liquid file only references it. */
(function(){
      var path = window.location.pathname.toLowerCase();
      if (path.indexOf('/blogs/the-journal/') !== 0) return;

      function ready(fn){
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', fn, { once: true });
        } else {
          fn();
        }
      }

      function card(item, index){
        return '<a class="tlc-journal-shop__card" href="' + item.url + '">' +
          '<span class="tlc-journal-shop__img"><img src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '" loading="lazy" width="1200" height="630"></span>' +
          '<span><span class="tlc-journal-shop__step">' + item.step + '</span>' +
          '<h3>' + item.title + '</h3>' +
          '<span class="tlc-journal-shop__why">' + item.why + '</span>' +
          '<span class="tlc-journal-shop__row"><span class="tlc-journal-shop__price">' + item.price + '</span><span class="tlc-journal-shop__cta">Shop</span></span>' +
          '</span></a>';
      }

      function render(block, route){
        var title = block.querySelector('.tlc-journal-shop__top h2');
        var lead = block.querySelector('.tlc-journal-shop__lead');
        var grid = block.querySelector('.tlc-journal-shop__grid');
        var all = block.querySelector('.tlc-journal-shop__all');
        if (!title || !lead || !grid || !all) return;
        title.textContent = route.title;
        lead.textContent = route.lead;
        grid.innerHTML = route.products.map(card).join('');
        all.href = route.collection;
        all.textContent = route.label + ' ->';
      }

      ready(function(){
        var block = document.querySelector('.tlc-journal-shop');
        if (!block) return;
        var acneRoute = path.indexOf('acne') > -1 || path.indexOf('bacne') > -1 || path.indexOf('salicylic') > -1;
        if (!acneRoute) return;
        render(block, {
          title: 'Shop the exact bacne ritual.',
          lead: 'Back acne does not need vague advice. Cleanse, treat the hard-to-reach zones, then stay consistent.',
          collection: '/collections/acne',
          label: 'Shop acne care',
          products: [
            { step: 'Cleanse', title: '2% Salicylic Acid Body Wash - Bacne Treatment', url: '/products/active-2-salicylic-acid-body-cleanser', image: 'https://theloveco.in/cdn/shop/files/SALICYLICACIDCLEANSER.png?crop=center&height=630&v=1773833063&width=1200', why: '2% salicylic acid in the shower for body breakouts.', price: '₹399' },
            { step: 'Treat', title: 'Bacne Spray - 2% Salicylic Acid Body Spray', url: '/products/bacne-warrior-acne-fighting-body-spray', image: 'https://theloveco.in/cdn/shop/files/bacne_spray_3.png?crop=center&height=630&v=1771324904&width=1200', why: 'Spray format reaches the back, shoulders and chest.', price: '₹799' }
          ]
        });
      });
    })();
